import { parseISO, format, startOfWeek, endOfWeek, isValid, isAfter, startOfDay } from 'date-fns';

export const formatWeekKey = (key: string): string => {
    if (!key) return '';
    const [startStr, endStr] = key.split('_'); // "2025-12-04_2025-12-10"
    if (!startStr || !endStr) return '';

    const start = parseISO(startStr);
    const end = parseISO(endStr);
    if (!isValid(start) || !isValid(end)) return '';

    return `${format(start, 'd MMM')} - ${format(end, 'd MMM')}`;
    // e.g. "30 Nov - 6 Dec"
};

export const formatDateKey = (key: string): string => {
    if (!key) return '';
    const date = parseISO(key);
    if (!isValid(date)) return '';
    return `${format(date, 'd MMM yyyy')}`;
    // e.g. "30 Nov 2025"
};

export const getDateFromWeekKey = (key: string): string => {
    if (!key) return '';
    const [, endStr] = key.split('_');
    if (!endStr) return '';

    const end = parseISO(endStr);
    if (!isValid(end)) return '';

    const todayStart = startOfDay(new Date());
    if (isAfter(startOfDay(end), todayStart)) {
        return format(todayStart, 'yyyy-MM-dd');
    }
    return endStr;
};

export const checkIfDateIsWeekKey = (key: string): boolean => {
    if (!key) return false;
    return key.includes('_');
}

export const getWeekKeyFromDate = (date: string): string => {
    if (!date) return '';
    const dateObj = parseISO(date);
    if (!isValid(dateObj)) return '';
    const weekStart = startOfWeek(dateObj, { weekStartsOn: 0 });
    const weekEnd = endOfWeek(dateObj, { weekStartsOn: 0 });
    return `${format(weekStart, 'yyyy-MM-dd')}_${format(weekEnd, 'yyyy-MM-dd')}`;
};
